import React, { useState } from "react";
import './inputfield.scss';
import Error from '../Error/error';

const InputField = (props) => {
    const {
        id,
        label,
        placeholder,
        required,
        multiline,
        rows,
        errorMessage,
        handleBlur,
        handleChange,
        ...restOfProps
    } = props;

    const [touched, setTouched] = useState(false); // Track if the field has been touched

    const onBlur = (e) => {
        setTouched(true); // Mark the field as touched
        if (handleBlur) {
            handleBlur(id, e.target.value, !!required); // Call handleBlur from parent
        }
    };

    const onChange = (e) => {
        if (handleChange) {
            handleChange(id, e.target.value, !!required); // Call handleChange from parent
        }
    };

    const inputClass = `form-control ${errorMessage ? 'error' : ''}`;

    return (
        <div className={`form-group ${errorMessage ? 'error' : ''}`}>
            <label htmlFor={id}>
                {label}
                {required && <span className="small"> (required)</span>}
            </label>
            {multiline ? (
                <textarea
                    id={id}
                    className={inputClass}
                    placeholder={placeholder}
                    rows={rows || 4}
                    onBlur={onBlur} // Trigger validation on blur
                    onChange={onChange} // Trigger validation on change
                    required={required}
                    {...restOfProps}
                />
            ) : (
                <input
                    id={id}
                    className={inputClass}
                    placeholder={placeholder}
                    onBlur={onBlur} // Trigger validation on blur
                    onChange={onChange} // Trigger validation on change
                    required={required}
                    {...restOfProps}
                />
            )}
            {errorMessage && <Error message={errorMessage || "This field is required"} />}
        </div>
    );
};

InputField.defaultProps = {
    type: "text",
    customsize: "",
    contextualmessage: "",
    errorMessage: ""
};

export default InputField;